// extracted by mini-css-extract-plugin
module.exports = {"legend":"BarChart_legend__2uRSn","chartLegend":"BarChart_chartLegend__3CmTI","legendBar":"BarChart_legendBar__sp38n","text":"BarChart_text__2ynBG","line":"BarChart_line__3aElc"};